import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Pagination,
  Paper,
  Select,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { getCyclesApi } from '../../../api/patientApi';
import { toast } from 'sonner';
import { Typography } from 'antd';
import dayjs from 'dayjs';

/**
 *
 * Pending:
 * 1. spouseName
 * 2. treatmentPlan
 */
const OngoingCycles = () => {
  const [cycles, setCycles] = useState([]);
  const [totalCycles, setTotalCycles] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { cycles, totalCycles } = await getCyclesApi(page, pageSize);
        console.log(cycles, totalCycles);
        setCycles(cycles);
        // setTotalCycles(totalCycles);
      } catch (err) {
        toast.error('Error fetching patients');
        console.error('error fetching cycles', err);
      }
      setLoading(false);
    })();
  }, [page, pageSize]);

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>NAME OF THE PATIENT</TableCell>
              <TableCell>PATIENT ID</TableCell>
              <TableCell>SPOUSE NAME</TableCell>
              <TableCell>TREATMENT PLAN</TableCell>
              <TableCell>DAY OF MEDICATION</TableCell>
              <TableCell>NAME OF PROCEDURE</TableCell>
              <TableCell>DATE OF PROCEDURE</TableCell>
              <TableCell>TIME OF PROCEDURE</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <div>Loading....</div>
            ) : cycles.length <= 0 ? (
              <Typography
                component="p"
                sx={{
                  textAlign: 'center',
                  width: '100%',
                }}
              >
                No Patients Found
              </Typography>
            ) : (
              cycles.map((cycle, index) => {
                const { patient } = cycle;
                return (
                  <TableRow key={index}>
                    <TableCell>
                      {patient.firstName} {patient.lastName}
                    </TableCell>
                    <TableCell>{patient.upid}</TableCell>
                    <TableCell>
                      {patient.partner?.firstName === ''
                        ? 'N/A'
                        : patient.partner?.firstName}
                    </TableCell>
                    <TableCell>
                      {cycle.fmsData.treatmentPlanForm
                        ? cycle.fmsData.treatmentPlanForm.customTreatmentPlan
                        : 'N/A'}
                    </TableCell>
                    {cycle.fmsData.triggerDate ? (
                      <TableCell>
                        {new Date(
                          cycle.fmsData.triggerDate,
                        ).toLocaleDateString()}
                      </TableCell>
                    ) : (
                      <TableCell>N/A</TableCell>
                    )}
                    <TableCell>
                      {cycle.fmsData.stimulationProtocol[0].checked &&
                        cycle.fmsData.stimulationProtocol[0].name}
                      {cycle.fmsData.stimulationProtocol[1].checked &&
                        cycle.fmsData.stimulationProtocol[1].name}
                      {cycle.fmsData.stimulationProtocol[2].checked &&
                        cycle.fmsData.stimulationProtocol[2].name}
                    </TableCell>
                    {cycle.fmsData.procedureDate ? (
                      <TableCell>
                        {new Date(
                          cycle.fmsData.procedureDate,
                        ).toLocaleDateString()}
                      </TableCell>
                    ) : (
                      <TableCell>N/A</TableCell>
                    )}
                    {cycle.fmsData.procedureTime ? (
                      <TableCell>{cycle.fmsData.procedureTime}</TableCell>
                    ) : (
                      <TableCell>N/A</TableCell>
                    )}
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        count={Math.ceil(totalCycles / pageSize)}
        page={page}
        onChange={(event, value) => setPage(value)}
        color="primary"
        style={{
          marginTop: '20px',
          display: 'flex',
          justifyContent: 'center',
        }}
      />

      <FormControl
        variant="outlined"
        style={{ minWidth: 120, marginBottom: '20px' }}
      >
        <InputLabel id="page-size-label">Page Size</InputLabel>
        <Select
          labelId="page-size-label"
          id="page-size-select"
          value={pageSize}
          onChange={(e) => {
            setPageSize(e.target.value);
          }}
          label="Page Size"
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={15}>15</MenuItem>
          <MenuItem value={20}>20</MenuItem>
        </Select>
      </FormControl>
    </>
  );
};

export default OngoingCycles;
